// Display · EnumChips
//
// Renders an ARRAY of enum values as a wrapped row of tone-coded chips
// (StatusChipShell each). The generator's default display for array-enum columns
// (e.g. company `categories`), driven by a columnEnums binding's tones + labels.

import { Inline } from "@ds/layout/Inline";
import { StatusChipShell } from "./StatusChipShell";
import { TextValue } from "./TextValue";
import type { PillSize } from "@ds/display/Pill";
import type { ToneName } from "@ds/tokens/palette";

export interface EnumChipsInput {
  values: readonly string[] | null | undefined;
  /** value → ToneName. */
  tones: Record<string, ToneName>;
  /** value → display label. */
  labels: Record<string, string>;
  size?: PillSize;
  testId?: string;
}

export type EnumChipsProps = EnumChipsInput;

export function EnumChips({ values, tones, labels, size = "sm", testId }: EnumChipsProps) {
  if (!values || values.length === 0) return <TextValue value={undefined} testId={testId} />;
  return (
    <Inline gap="xs" wrap>
      {values.map((v) => (
        <StatusChipShell key={v} tone={tones[v] ?? "grey"} label={labels[v] ?? v} size={size} />
      ))}
    </Inline>
  );
}
